import React, { Suspense, Fragment, memo } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import * as theme from "../shared/theme";
import { Container, medium } from "../shared/grid";
import { CapsuleLinkButton } from "../shared/elements";
import Header from "./Header";
import ServiceCard from "../shared/ServiceCard";
import FlightCard from "../shared/FlightCard";
import PaymentCard from "../shared/PaymentCard";
import SERVICES from "../../constants/servicesCarey";
import getTokenTransactions from "../../utils/dragonGlass";

// require("dotenv").config();

const tokenId = process.env.REACT_APP_TOKEN_ID;
console.log("tokenId: ", tokenId);
const apiKey = process.env.REACT_APP_DRAGONGLASS_KEY;
console.log("apiKey: ", apiKey);
const accountId = process.env.REACT_APP_ACCOUNT_ID_2;
console.log("accountId: ", accountId);
// const data = getTokenTransactions(tokenId, apiKey);
// console.log("data: ", data);

class PassengerHome extends React.Component {

  constructor () {
    super()
    this.state = {
      loading: false,
      transactions: []}
  }

  componentDidMount() {
    fetch(`https://api-testnet.dragonglass.me/hedera/api/hts/tokens/${tokenId}/transfers?accountId=${accountId}`, {
	    method: 'GET',
	    headers: {
		    'x-api-key': apiKey,
	    }
	  }).then(response => response.json())
      .then(json => this.setState({ loading: true, transactions: json.data }));
	    // .then(json => {
		  //   console.log("DATA IN APIS: ", tokenId);
		  //   console.log("DATA IN APIS: ", apiKey);
		  //   console.log("DATA IN APIS: ", json.data);
      //   this.setState({ loading: false, data: json });
	    // })
  }

  // constructor () {
  //   super()
  //   this.state = {
  //     transactions: [],
  //     loading: false}
  // }
  // componentDidMount() {
  //   data.then((value) => {
  //     this.setState({loading: true, transactions: value})
  //   })
  // }


  render() {
    // const { loading, data } = this.state;
    const { loading, transactions } = this.state;
    console.log("transactions data: ", transactions);
    console.log("loading data: ", loading);

    return (<Wrapper>
      <Header />
      <Cards>
      <Container><br/><br/><br/><br/>
      <h3 >MY IDENTITY</h3><br/><br/>
        <ServiceCard
          key={SERVICES.PASSENGER_ID.id}
          name={SERVICES.PASSENGER_ID.name}
          icon={SERVICES.PASSENGER_ID.icon}
          superText={SERVICES.PASSENGER_ID.entity}
          description={SERVICES.PASSENGER_ID.description}
          shareClaims={SERVICES.PASSENGER_ID.requiredClaims}
          shareServices={SERVICES.PASSENGER_ID.requiredServices}
          receiveClaims={SERVICES.PASSENGER_ID.generatedClaims}
          url={SERVICES.PASSENGER_ID.url}
          colors={theme.colors[SERVICES.PASSENGER_ID.id]} />
      </Container>
      </Cards>
      <Cards>
      <h3 ><br/>
      <br/><br/>MY DELIVERIES</h3><br/><br/>
        <Container>
          {Object.keys(SERVICES.PASSENGER_FLIGHTS).map(sid => <FlightCard
            key={SERVICES.PASSENGER_FLIGHTS[sid].id}
            name={SERVICES.PASSENGER_FLIGHTS[sid].name}
            icon={SERVICES.PASSENGER_FLIGHTS[sid].icon}
            superText={SERVICES.PASSENGER_FLIGHTS[sid].entity}
            description={SERVICES.PASSENGER_FLIGHTS[sid].description}
            shareClaims={SERVICES.PASSENGER_FLIGHTS[sid].requiredClaims}
            shareServices={SERVICES.PASSENGER_FLIGHTS[sid].requiredServices}
            receiveClaims={SERVICES.PASSENGER_FLIGHTS[sid].generatedClaims}
            url={SERVICES.PASSENGER_FLIGHTS[sid].url}
            colors={theme.colors[SERVICES.PASSENGER_FLIGHTS[sid].id]} />)}
        </Container>
      </Cards>
      <Cards>
      <h3 ><br/>
      <br/><br/>MY Payments</h3><br/><br/>
      <Container>
        <React.Fragment>{loading ? transactions.map(transaction => <PaymentCard
          name={transaction.transactionId}
          description={transaction.accountId}
          amount={transaction.amount}
          time={transaction.transferTime}
          colors='Payments' />) : 'Classic loading placeholder'}</React.Fragment>
      </Container>
      </Cards>
    </Wrapper>)
  }
}

const Hero = styled.div`
  overflow: hidden;
  position: relative;
`;


const Wrapper = styled.div`
  ${props => props.extraPadding
    ? `padding-bottom: 6rem;`
    : ""}

  h3 {
    font-size: 1.5rem;
    color: white;
    font-weight: 1000;
    margin: 0 0 60px;
    text-align: center;
    text-transform: uppercase;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
const Cards = styled.div`
  background: ${theme.gradient1};

  ${Container} {
    padding: 1px 20px 30px;
    ${medium("padding: 1px 0 40px;")}
  }
`;

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(PassengerHome);
